module.exports = {
    padding: 10,
    background: 'rgb(204, 0, 0)',
    color: 'white',
    fontFamily: 'sans-serif',
    fontSize: '14px',
    fontWeight: 'bold',
    whiteSpace: 'pre',
    overflow: 'auto'
};


// WEBPACK FOOTER //
// ./~/picidae-transformer-react-render/lib/error-style.js